import { faCalendar, faHouse, faShoppingBasket } from '@fortawesome/pro-light-svg-icons'
import { OrderAppointmentState, OrderPhase, OrderState } from '../model'

export const DASHBOARD_ROUTES = [
    {
        to: '',
        icon: faHouse,
        displayName: 'Dashboard'
    },

    {
        to: 'orders',
        icon: faShoppingBasket,
        displayName: 'Opdrachten'
    },
    {
        to: 'appointments',
        icon: faCalendar,
        displayName: 'Afspraken',
        disabled: true
    }

    // {
    //     to: 'settings',
    //     icon: faGear,
    //     displayName: 'Instellingen'
    // }
]

export const ORDER_PHASES = [
    {
        value: OrderPhase.Active,
        hexColor: '#696969',
        label: 'In behandeling',
        showInFilter: true
    },
    {
        value: OrderPhase.Completed,
        hexColor: '#D20C60',
        label: 'Opgeleverd',
        showInFilter: true
    },
    {
        value: OrderPhase.Archived,
        hexColor: '#2EB5AD',
        label: 'Gearchiveerd',
        showInFilter: false
    }
]

export const APPOINTMENT_STATES = [
    {
        value: OrderAppointmentState.Confirmed,
        hexColor: '#2EB5AD',
        label: 'gemaakt'
    },
    {
        value: OrderAppointmentState.Cancelled,
        hexColor: '#C52222',
        label: 'geannuleerd'
    }
]

export const DELIVERY_CATEGORIES = [
    {
        value: 'cat1',
        label: 'Categorie 1'
    },
    {
        value: 'cat2',
        label: 'Categorie 2'
    },
    {
        value: 'cat3',
        label: 'Categorie 3'
    }
]

export const ORDER_STATES = [
    {
        value: OrderState.Assigned,
        label: 'Akkoord'
    },
    {
        value: OrderState.Requested,
        label: 'Wacht op akkoord'
    },
    {
        value: OrderState.Processing,
        label: 'In behandeling'
    },
    {
        value: OrderState.Delivered,
        label: 'Opgeleverd'
    }
]

export const DEFAULT_BRANDING = {
    organisation: 'Tibi Media',
    description: 'De one-stop-shop voor vastgoedpresentatie',
    logo: {
        default: '/b25def69036106c1fda652d079cef59c.svg',
        favicon: '/faviconTM.ico',
        appleTouchIcon: '/apple-touch-icon.png',
        favicon16x16: '/favicon-16x16.png',
        favicon32x32: '/favicon-32x32.png'
    },
    colors: {
        primary: '#C75555',
        blushPrimary: '#fff7f7',
        fadedPrimary: '#D4C5C5',
        lightPrimary: '#420B2208',
        linkColor: '#4B4B88',
        mainHeading: '#000000',
        lightGray: '#DCDCDC',
        text: '#494A49',
        textLight: '#696969',
        green: '#2EB5AD',
        lightGreen: '#B2E2DF'
    },
    manifest: {
        short_name: 'Tibi Media',
        name: 'Tibi Media',
        id: 'tb_tibi',
        description: 'De one-stop-shop voor vastgoedpresentatie',
        icons: [
            { src: '/android-chrome-192x192.png', sizes: '192x192', type: 'image/png' },
            { src: '/android-chrome-512x512.png', sizes: '512x512', type: 'image/png' }
        ],
        start_url: '/dashboard',
        display: 'standalone',
        theme_color: '#000000',
        background_color: '#ffffff'
    },
    termsAndConditionsUrl: 'https://www.tibimedia.nl/algemene-voorwaarden/'
}
